export abstract class DropDeskException {
    abstract message: string;
    abstract humanMessage?: string;
}

export class SignInError extends DropDeskException {
    message: string;
    humanMessage?: string;

    constructor(messageError: string) {
        super();
        this.message = messageError;
    }
}


export class ServerError extends DropDeskException {
    message: string;
    humanMessage?: string;

    constructor(messageError: string, humanMessage?: string) {
        super();
        this.message = messageError;
        this.humanMessage = humanMessage;
    }
}

export class DropDeskError extends DropDeskException {
    message: string;
    humanMessage?: string;

    constructor(messageError: string) {
        super();
        this.message = messageError;
    }
}

export class SubscriptionException extends DropDeskException {
    message: string;
    humanMessage?: string;

    constructor(messageError: string) {
        super();
        this.message = messageError;
    }
}
